<template>
  <div id="rssFeedManagment">
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
      :property-mapping="errorPropertyMappings"
    />
    <div>
      <div class="form-group mb-4">
        <b-container class="pb-0 pt-0">
          <b-row class="mt-4">
            <label class="pl-0 col-3 defaultLabel"> Text </label>
            <div class="col-9 pl-0">
              <input
                id="feedTextSearchInput"
                v-model="sortFilter.textFilter"
                type="text"
                class="form-control col-6"
                placeholder="nach Text filtern"
              >
            </div>
          </b-row>
          <b-row class="mt-4">
            <label class="pl-0 col-3 defaultLabel"> Status </label>
            <div class="col-9 pl-0">
              <select
                id="feedEntryStatusSearchSelect"
                v-model="sortFilter.status"
                class="form-control col-6"
                title="Status"
              >
                <option :value="-1">
                  --
                </option>
                <option
                  v-for="(status, index) in feedEntryStatus"
                  :key="index"
                  :value="status.value"
                >
                  {{ status.name }}
                </option>
              </select>
            </div>
          </b-row>
          <b-row
            v-if="tenants"
            class="mt-4"
          >
            <label class="pl-0 col-3 defaultLabel"> Tenant </label>
            <div class="col-9 pl-0">
              <select
                id="feedEntryStatusSearchSelect"
                v-model="sortFilter.tenant"
                class="form-control col-6"
                title="Status"
              >
                <option :value="-1">
                  --
                </option>
                <option
                  v-for="(tenant, index) in tenants"
                  :key="index"
                  :value="tenant.id"
                >
                  {{ tenant.bezeichnung }}
                </option>
              </select>
            </div>
          </b-row>
        </b-container>
      </div>
      <div class="w-100 mt-4">
        <NewFeedEntry
          modal-id="topAddButton"
          class="float-right"
          @feedAdded="getAllRssFeeds"
        />
      </div>
      <u-loader v-if="isLoading" />
      <table
        v-else
        class="w-100 feedTable ml-2 mt-4"
      >
        <thead>
          <tr>
            <th>Informationen</th>
            <th>Deutsch</th>
            <th>Französisch</th>
            <th>Italienisch</th>
            <th
              class="cursor-pointer"
              @click="sortByPublicationDate()"
            >
              <div class="float-left mr-1">
                Publiziert
              </div>
              <u-sorting-up-down :value="sortFilter.publishedSorted" />
            </th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(newsFeed, index) in allFeedEntries"
            :key="index"
          >
            <td>
              <div v-if="newsFeed.contractNumber">
                <router-link
                  :to="
                    '/contract-overview/' +
                      newsFeed.contractNumber +
                      '/' +
                      newsFeed.versionNumber
                  "
                >
                  {{ newsFeed.contractName }}
                </router-link>
              </div>
              <!-- ID: {{ newsFeed.feedId }}<br> -->
              <div v-if="tenants">
                Kanal:
                <span
                  v-for="(feedTenant, tenantIndex) in newsFeed.tenants.filter(
                    (tenant) => {
                      return tenant != null;
                    },
                  )"
                  :key="tenantIndex"
                >{{
                  tenants.filter((tenant) => {
                    return tenant.id == feedTenant;
                  })[0].bezeichnung
                }}<span
                  v-if="newsFeed.tenants.length > tenantIndex + 1"
                >,
                </span></span>
              </div>
              Status:
              {{
                feedEntryStatus.filter((state) => {
                  return state.value == newsFeed.status;
                })[0].name
              }}<br>
            </td>
            <td
              v-if="
                newsFeed.feedEntryContents.filter((entry) => {
                  return entry.language == 'de-CH';
                })[0]
              "
            >
              {{
                newsFeed.feedEntryContents.filter((entry) => {
                  return entry.language == "de-CH";
                })[0].value
              }}
            </td>
            <td v-else />
            <td
              v-if="
                newsFeed.feedEntryContents.filter((entry) => {
                  return entry.language == 'fr-CH';
                })[0]
              "
            >
              {{
                newsFeed.feedEntryContents.filter((entry) => {
                  return entry.language == "fr-CH";
                })[0].value
              }}
            </td>
            <td v-else />
            <td
              v-if="
                newsFeed.feedEntryContents.filter((entry) => {
                  return entry.language == 'it-CH';
                })[0]
              "
            >
              {{
                newsFeed.feedEntryContents.filter((entry) => {
                  return entry.language == "it-CH";
                })[0].value
              }}
            </td>
            <td v-else />
            <td>
              {{
                newsFeed.publicationDate
                  ? $moment(newsFeed.publicationDate).format("DD.MM.YYYY")
                  : "-"
              }}
            </td>
            <td>
              <EditExistingFeedEntry
                :entry-to-edit-id="newsFeed.feedId"
                class="float-left"
                @updatedEntry="getAllRssFeeds"
              />
              <button
                v-b-modal="'deleteFeedEntry'"
                v-b-tooltip.hover
                type="button"
                placement="bottom"
                title="Feed-Eintrag löschen"
                class="btn btn-danger smallActionButton ml-1"
                @click="feedEntryToDeleteId = newsFeed.feedId"
              >
                <i class="fas fa-trash-alt" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination
        v-model="sortFilter.page"
        :total-rows="totalResults"
        :per-page="resultsPerPage"
        prev-text="Vorherige"
        next-text="Nächste"
        first-text="<<"
        last-text=">>"
        class="mt-4"
      />
      <div class="w-100 mt-4">
        <NewFeedEntry
          modal-id="bottomAddButton"
          class="float-right"
          @feedAdded="getAllRssFeeds"
        />
      </div>
      <b-modal
        id="deleteFeedEntry"
        ref="deleteFeedEntry"
        no-fade
        hide-footer
        title="Feed-Eintrag löschen"
      >
        <div class="d-block mb-4">
          <div class="d-block mb-4">
            Sind Sie sicher, dass Sie diesen Feed-Eintrag löschen möchten?
          </div>
          <b-button
            variant="success"
            @click="deleteEntry()"
          >
            Löschen
          </b-button>
          <b-button
            class="ml-2"
            variant
            @click="hideModal"
          >
            Abbrechen
          </b-button>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import {
  SearchFeedEntries,
  DeleteFeedEntry,
} from "@/services/rssFeed.service.js";
import NewFeedEntry from "@/components/rssFeed/NewFeedEntry.vue";
import USortingUpDown from "@/components/common/USortingUpDown.vue";
import EditExistingFeedEntry from "@/components/rssFeed/EditExistingFeedEntry.vue";
import { GetAvailableTenants } from "@/services/contract.tenants.service.js";

export default {
  components: {
    NewFeedEntry,
    EditExistingFeedEntry,
    USortingUpDown,
  },
  data() {
    return {
      isLoading: false,
      errorObject: null,
      allFeedEntries: [],
      totalResults: 0,
      feedEntryToDeleteId: null,
      feedEntryStatus: [
        { value: 0, name: "" },
        { value: 1, name: "Entwurf" },
        { value: 2, name: "Publiziert" },
      ],
      resultsPerPage: 15,
      sortFilter: {
        publishedSorted: -1,
        textFilter: "",
        status: -1,
        tenant: -1,
        page: 1,
      },
      searchQueryQueue: [],
    };
  },
  watch: {
    "sortFilter.page"() {
      this.GetFeedsFiltered();
    },
    "sortFilter.textFilter"() {
      this.GetFeedsFiltered();
    },
    "sortFilter.tenant"() {
      this.GetFeedsFiltered();
    },
    "sortFilter.status"() {
      this.GetFeedsFiltered();
    },
  },
  created() {
    this.loadTenants();
    this.getAllRssFeeds();
  },
  methods: {
    hideModal() {
      this.$refs["deleteFeedEntry"].hide();
    },
    deleteEntry() {
      if (this.feedEntryToDeleteId) {
        this.errorObject = null;
        this.isLoading = false;
        this.hideModal();

        DeleteFeedEntry(
          this.feedEntryToDeleteId,
          () => {
            this.isLoading = false;
            this.getAllRssFeeds();
          },
          (error) => {
            this.errorObject = error;
            this.hideModal();
            this.isLoading = false;
          },
        );
      }
    },
    GetFeedsFiltered(immediateReload) {
      if (immediateReload) {
        this.getAllRssFeeds();
        return;
      }

      this.isLoading = true;
      this.errorObject = null;
      this.allFeedEntries = [];

      this.searchQueryQueue.push(new Date().getTime());
      setTimeout(() => {
        if (this.searchQueryQueue.length > 1) {
          this.searchQueryQueue = this.searchQueryQueue.slice(1);
          return;
        }

        this.getAllRssFeeds();
      }, 400);
    },
    getAllRssFeeds() {
      this.searchQueryQueue = [];
      this.isLoading = true;
      this.errorObject = null;

      var requestObject = {
        SearchString: this.sortFilter.textFilter,
        TenantId: this.sortFilter.tenant != -1 ? this.sortFilter.tenant : "",
        Status: this.sortFilter.status != -1 ? this.sortFilter.status : "",
        SortBy: "PublicationDate",
        SortOrder:
          this.sortFilter.publishedSorted != -1
            ? this.sortFilter.publishedSorted.toString()
            : "",
        PageSize: this.resultsPerPage,
        PageNumber: this.sortFilter.page,
      };

      SearchFeedEntries(
        requestObject,
        (result) => {
          this.allFeedEntries = [];
          let newFeedEntries = [];
          result.feedEntries.map((resultEntry) => {
            resultEntry.tenants = [];
            var existingFeed = this.allFeedEntries.filter((entry) => {
              return entry.feedId == resultEntry.feedId;
            });

            if (existingFeed[0] && resultEntry.tenantId) {
              existingFeed[0].tenants.push(resultEntry.tenantId);
            } else {
              if (resultEntry.tenantId) {
                resultEntry.tenants = [resultEntry.tenantId];
              }

              newFeedEntries.push(resultEntry);
            }
          });

          this.allFeedEntries = newFeedEntries;
          this.totalResults = result.numberOfItems;
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    sortByPublicationDate() {
      this.sortFilter.publishedSorted == 1
        ? (this.sortFilter.publishedSorted = -1)
        : this.sortFilter.publishedSorted == -1
          ? (this.sortFilter.publishedSorted = 0)
          : (this.sortFilter.publishedSorted = 1);

      this.GetFeedsFiltered();
    },
    loadTenants() {
      GetAvailableTenants(
        (response) => {
          this.tenants = response;
        },
        () => {},
      );
    },
  },
};
</script>

<style>
#rssFeedManagment .page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #ff5959;
  border-color: red;
}
#rssFeedManagment .page-link:hover {
  z-index: 2;
  color: red;
  text-decoration: none;
  background-color: #fdd;
  border-color: #fdd;
}

#rssFeedManagment a:hover {
  color: #0056b3;
  text-decoration: underline;
}

#rssFeedManagment .page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: red;
  background-color: rgb(255, 255, 255);
  border: 1px solid #dee2e6;
}
</style>

<style scoped>
.feedText {
  color: rgb(168, 168, 168);
}

.smallActionButton {
  width: 25px;
  height: 25px;
  font-size: 17px;
  padding: 0px;
}

.feedTable {
  font-size: small;
  table-layout: fixed;
}

.feedTable thead th:nth-child(1) {
  width: 22%;
}
.feedTable thead th:nth-child(2) {
  width: 18%;
}
.feedTable thead th:nth-child(3) {
  width: 18%;
}
.feedTable thead th:nth-child(4) {
  width: 18%;
}
.feedTable thead th:nth-child(5) {
  width: 8%;
}
.feedTable thead th:nth-child(6) {
  width: 8%;
}
.feedTable tbody tr {
  border-bottom: 1px solid gainsboro;
}
.feedTable td,
.feedTable th {
  padding: 8px 4px;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
